import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

const rawUrl = import.meta.env.VITE_SUPABASE_URL;
const rawKey =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? import.meta.env.VITE_SUPABASE_ANON_KEY;

const SUPABASE_URL = typeof rawUrl === "string" ? rawUrl.replace(/^["']|["']$/g, "").trim() : "";
const SUPABASE_KEY = typeof rawKey === "string" ? rawKey.replace(/^["']|["']$/g, "").trim() : "";

if (import.meta.env.DEV && (!SUPABASE_URL || !SUPABASE_KEY)) {
  console.error(
    "[Supabase] Faltan variables en .env. Necesitas VITE_SUPABASE_URL y una clave publica:\n" +
      "  - VITE_SUPABASE_PUBLISHABLE_KEY (clave publishable sb_...) o\n" +
      "  - VITE_SUPABASE_ANON_KEY (JWT anon eyJ...)\n" +
      "Copia .env.example a .env, rellena y reinicia `npm run dev`.",
  );
}

export const supabase = createClient<Database>(SUPABASE_URL || "https://placeholder.local", SUPABASE_KEY || "placeholder", {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});